import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import MembersList from './members/MembersList';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import AddEditMembers from './members/AddEditMembers';
import MemberArchived from './members/MemberArchived';
import OnboardingStatus from './members/OnboardingStatus';
import { getTeams, getTitle } from '../../../redux/MainAction';

const PeopleMeberTab = () => {
  const tmlist = useSelector((state) => state.Webtracker.member);
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('home1'); // Track active tab

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  useEffect(() => {
    dispatch(getTitle());
  }, []);

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className=" d-flex align-items-center mb-2 ">
            <h5 h5 className="text-muted col-9"></h5>
            <div
              className="col-3 d-flex justify-content-end align-items-center"
              style={{ gap: '20px' }}
            >
              <Button
                className="d-flex align-items-center text-white"
                color="primary"
                size="sm"
                onClick={toggleModal}
              >
                <i className="mdi mdi-plus mr-2"></i> Invite
              </Button>
            </div>
          </div>
          {isModalOpen && (
            <AddEditMembers open={isModalOpen} onClose={toggleModal} />
          )}
          <div className="row">
            <div className="col-12">
              <div className="card m-b-20">
                <div className="card-body">
                  <ul className="nav nav-tabs nav-tabs-custom " role="tablist">
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === 'home1' ? 'active' : ''}`}
                        href="#home1"
                        role="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          handleTabClick('home1');
                        }}
                      >
                        <span className="d-none d-md-block">
                          Members {tmlist?.count}
                        </span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-home-variant h5"></i>
                        </span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === 'onboard1' ? 'active' : ''}`}
                        href="#onboard1"
                        role="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          handleTabClick('onboard1');
                        }}
                      >
                        <span className="d-none d-md-block">
                          Onboarding Status
                        </span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-account h5"></i>
                        </span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${activeTab === 'archived2' ? 'active' : ''}`}
                        href="#archived2"
                        role="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          handleTabClick('archived2');
                        }}
                      >
                        <span className="d-none d-md-block">Archived</span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-account h5"></i>
                        </span>
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content">
                    {activeTab === 'home1' && (
                      <div
                        className="tab-pane active"
                        id="home1"
                        role="tabpanel"
                      >
                        <MembersList data={tmlist?.rows} />
                      </div>
                    )}

                    {activeTab === 'archived2' && (
                      <div
                        className="tab-pane active"
                        id="archived2"
                        role="tabpanel"
                      >
                        <MemberArchived />
                      </div>
                    )}

                    {activeTab === 'onboard1' && (
                      <div
                        className="tab-pane active"
                        id="onboard1"
                        role="tabpanel"
                      >
                        <OnboardingStatus />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default PeopleMeberTab;
